import React, { Component } from 'react';
import { Flex } from 'reflexbox';
import './Login.css';
import logo from './logo.png';
import { observer, inject } from 'mobx-react';
import { Redirect, withRouter } from 'react-router-dom';

import { stringHelper } from '../../helpers';

@withRouter
@inject('authStore', 'translationsStore', 'commonStore')
@observer
class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      finalUrl: '/registrations'
    };
    this.props.authStore.logout();
  }

  componentDidMount() {
    const { location } = this.props;
    if (location.search) {
      const qs = stringHelper.queryStringAsObject(location.search);

      if (!!qs.finalUrl) {
        this.setState({ finalUrl: qs.finalUrl });
      }

      if (!!qs.token) {
        this.setState({ loginByToken: true });
        this.props.authStore.refreshToken(qs.token).then(() => {
          this.setState({ loginByToken: false });
        });
      }
    }
  }

  componentWillUnmount = () => {
    this.setState({ loginByToken: false, finalUrl: '/registrations' });
  };

  handleEmailChange = e => this.props.authStore.setEmail(e.target.value);
  handlePasswordChange = e => this.props.authStore.setPassword(e.target.value);

  handleSubmitForm = e => {
    e.preventDefault();
    this.props.authStore.login();
  };

  render() {
    const { isLoggedIn } = this.props.commonStore;
    if (!isLoggedIn) {
      return (
        <Flex column align="center" justify="center" style={{ height: '100%' }} className="Login">
          <div>
            <img src={logo} alt="Air" style={{ width: '132px' }} />
          </div>
          <div className="title">{this.props.translationsStore.current['home']['header']}</div>
          <form name="signin" onSubmit={this.handleSubmitForm}>
            <Flex column>
              <input type="email" name="email" placeholder={this.props.translationsStore.current['home']['lblEmail']} onChange={this.handleEmailChange} required />
              <input type="password" name="password" onChange={this.handlePasswordChange} placeholder={this.props.translationsStore.current['home']['lblPassword']} required />
              <input type="submit" value={this.props.translationsStore.current['home']['btnSubmit']} />
            </Flex>
          </form>
        </Flex>
      );
    } else {
      return <Redirect to={this.state.finalUrl} />;
    }
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login/Login.js